






































import { useQuery, useResult } from '@vue/apollo-composable';
import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter } from '@ideavivat/vivat-2';

import getVehicles from '@/gql/vehicle/getVehicles.gql';
import { PaginatorInfo } from '@/types/paginatorInfo';
import useAuth from '@/useAuth';

const VehicleList = defineComponent({
  setup() {
    const { route, router } = useRouter();
    const { me } = useAuth();

    const filterVehicleDropdown = ['เลขทะเบียนรถ', 'ประเภทของรถ'];
    const filterVehicleValues = ['license', 'model'];
    const selectedFilterVehicle = ref('ประเภทของรถ');
    const selectedFilterVehicleValue = computed(() => filterVehicleValues[filterVehicleDropdown.indexOf(selectedFilterVehicle.value)]);

    const search = reactive({
      vehicleName: '',
      vehicleSearchInput: '',
      pendingVehicleSearch: false,
      vehicleSort: [{ column: 'license', order: 'DESC' }],
      vehicleSortInput: 'license',
    });

    const vehicleNameSearchHandler = _.debounce(() => {
      search.pendingVehicleSearch = true;
      search.vehicleName = search.vehicleSearchInput;
    }, 500);
    const vehicleSortHandler = _.debounce(() => {
      search.pendingVehicleSearch = true;
      search.vehicleSort = [{ column: search.vehicleSortInput, order: 'DESC' }];
    });

    const vehicles: Ref<any> = ref([]);
    const vehiclePaginatorInfo: Ref<PaginatorInfo> = ref({});
    const vehiclesPage = ref(1);
    const { result: getVehiclesResult, loading: vehiclesLoading } = useQuery(getVehicles, computed(() => ({
      page: vehiclesPage.value,
      orderBy: search.vehicleSortInput !== '' ? search.vehicleSort : undefined,
      filter: search.vehicleName !== '' ? {
        OR: [
          { column: 'MODEL', operator: 'LIKE', value: `%${search.vehicleName}%` },
          { column: 'LICENSE', operator: 'LIKE', value: `%${search.vehicleName}%` },
        ],
      } : undefined,
      filterByReservedOnly: false,
    })), () => ({ fetchPolicy: 'network-only' }));
    const vehiclesResult = useResult(getVehiclesResult, [], (data) => data.vehicles);
    watch(() => vehiclesResult.value, (newVal, oldVal) => {
      if (!vehiclesLoading.value && newVal !== oldVal) {
        if (search.pendingVehicleSearch || vehiclesResult.value.paginatorInfo.currentPage === vehiclePaginatorInfo.value.currentPage) {
          vehicles.value = [];
          vehicles.value = vehiclesResult.value.data;
          vehiclesPage.value = 1;
          search.pendingVehicleSearch = false;
        } else vehicles.value = [...vehicles.value, ...vehiclesResult.value.data];
        vehiclePaginatorInfo.value = vehiclesResult.value.paginatorInfo;
      }
    });

    const selectVehicleHandler = (id: any) => {
      if (!(route.value.params.id === id)) router.push({ name: 'VehicleInformation', params: { id } });
      return false;
    };

    return {
      me,
      filterVehicleDropdown,
      selectedFilterVehicle,
      vehicleSortHandler,
      filterVehicleValues,

      search,
      vehicleNameSearchHandler,

      vehicles,
      vehiclePaginatorInfo,

      selectVehicleHandler,
    };
  },
});

export default VehicleList;
